export default __webpack_public_path__ + "static/Pontiac Vibe-b8c030c559e1c73bb3b6c4968b369254.jpg";